<template>
  <div class="d-flex align-center justify-end">
    <div class="w-50-porcento">
      <SysInputFormatadorValor
        v-model="produto.sugestao"
        v-on="inputListeners"
        ref="inputRef"
        :max-digitos="configuracoes.CASAS_DECIMAIS_CARRINHO"
        remover-valor-irrelevante
        centralizar
        :disabled="produto.produto_esta_combinado || produto.produto_eh_categoria"
        class="input-regular font-resp"
        @forcar-atualizacao-input="e => $emit('forcar-atualizacao-input', e)"
        @keydown.enter="adicionarNoCarrinhoComDaley()"
        @focus="$event.target.select();focado = true"
        @blur="focado = false"
        @click.stop
      >
        <template #sufixo>
          <div
            v-if="Number(produto.estoque_pendente) > 0"
            class="position-absolute font-11 text-green left-auto right-50-porcento top-2px cursor-help"
            :title="`Venda futura de ${formatarValor(produto.estoque_pendente)}`"
          >
            +{{ formatarValor(produto.estoque_pendente) }}
          </div>
        </template>
      </SysInputFormatadorValor>
    </div>

    <div class="w-50-porcento">
      <div v-if="produto.produto_eh_categoria" class="d-flex align-center justify-end">
        <v-btn
          :disabled="produto.sugestao <= 0"
          title="Adicionar no carrinho"
          icon
          @click.stop="$emit('add-produtos-categoria-no-carrinho', produto)"
        >
          <v-icon>mdi-cart</v-icon>
        </v-btn>
      </div>

      <div v-else class="d-flex align-center">

        <CompraProdutoNaoConfirmadaNoERP
          v-if="produto.compra_produto_nao_confirmada_no_erp"
          :id_grupo="produto.id_grupo"
          :produto_eh_combinacao="produto.produto_esta_combinado"
          :idproduto="produto.idproduto"
          @fazer-novo-pedido-compra="ev => $emit('fazer-novo-pedido-compra', ev)"
        />

        <DistribuirCompraPorFilial
          v-else-if="COMPRA_MULTIFILIAL_ATIVADA"
          :produto="{
            ...produto,
            idfornecedor: (FILTROS_STORE.fornecedores.length === 0) ? info_pedido_geral.idfornecedor : produto.idfornecedor,
            tempo_gatilho: produto.qtde_dias_gatilho_compra,
            qtd_pedidos_filial_com_produto: produto.qtd_pedidos_com_produto
          }"
          analise-grupo-fornecedores="N"
          :card_completar_compra="produto.em_completar_compra"
          @atualizar-listagem-produtos="ev => $emit('dialog-multifilial-fechado', ev)"
        />

        <template v-else>
          <ValidaLoteMinimo
            v-if="!LOTE_MINIMO_VALIDO"
            ref="loteMinimoRef"
            v-model.number="produto.sugestao"
            :lote-minimo="produto.lote_minimo"
            @change="adicionarNoCarrinhoComDaley()"
            @forcar-sugestao="$emit('add-produto-carrinho', produto)"
          />

          <AlertaEstoqueEstetico
            v-else-if="!ESTOQUE_ESTETICO_VALIDO"
            ref="alertaEstoqueEsteticoRef"
            v-model.number="produto.sugestao"
            :estoque_minimo="produto.estoque_minimo"
            :lote_minimo="produto.lote_minimo"
            :estoque="produto.estoque"
            :estoque_transito="produto.estoque_transito"
            @change="forcar_estoque_estetico = true;adicionarNoCarrinhoComDaley()"
            @forcar-sugestao="forcar_estoque_estetico = true;adicionarNoCarrinhoComDaley()"
          />

          <ValidacaoSugestaoVendaFutura
            v-else-if="!QUANTIDADE_VENDA_FUTURA_VALIDA"
            ref="alertaVendaFuturaRef"
            :quantidade_compra="Number(produto.sugestao)"
            :quantidade_sugestao="Number(produto.sugestao_fixa_convertivel)"
            :quantidade_venda_futura="Number(produto.estoque_pendente)"
            @aplicar-valor="valor => {
              nao_validar_venda_futura = true;
              produto.sugestao = valor;
              adicionarNoCarrinhoComDaley();
            }"
          />

          <v-btn v-else :disabled="produto.sugestao <= 0 || produto.produto_esta_combinado" title="Adicionar no carrinho" icon @click.stop="adicionarNoCarrinho()">
            <v-icon>mdi-cart</v-icon>
          </v-btn>
        </template>

        <DetalhamentoSugestaoCompra
          content_class="ml-n2"
          :produto="{
            ...produto,
            sugestao: produto.sugestao_unidade_padrao
          }"
          :card_completar_compra="produto.em_completar_compra"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SysInputFormatadorValor from "@/components/utils/InputFormatadorDeValor.vue";
import AlertaEstoqueEstetico from "../../SugestaoEstoqueEstetico.vue";
import ValidaLoteMinimo from '../../ValidaLoteMinimo.vue';
import {mapGetters} from "vuex";
import {verificarMultiploLoteMinimo} from "@/components/compra/CompraDistribuidaPorFilial/DistribuirCompraPorFilial/VerificaMuliploLoteMinimo";
import DistribuirCompraPorFilial from "@/components/compra/CompraDistribuidaPorFilial/DistribuirCompraPorFilial/Index.vue";
import {info_pedido_geral} from "@/components/compra/ProdutosGerais/InfoPedidoGeral";
import DetalhamentoSugestaoCompra from "@/components/produto/Compras/DetalhamentoSugestao/Index.vue";
import {formatarValor} from "@/helpers";
import ValidacaoSugestaoVendaFutura from "@/components/compra/ProdutosGerais/ValidacaoSugestao/VendaFutura/Index.vue";
import {validarVendaFutura} from "@/components/compra/ProdutosGerais/ValidacaoSugestao/VendaFutura/utils";
import CompraProdutoNaoConfirmadaNoERP from "@/components/produto/CompraProdutoNaoConfirmadaNoERP.vue";

export default {
  name: "SugestaoDeCompra",
  props: {
    produto: Object
  },
  components: {
    SysInputFormatadorValor,
    AlertaEstoqueEstetico,
    ValidaLoteMinimo,
    DistribuirCompraPorFilial,
    DetalhamentoSugestaoCompra,
    ValidacaoSugestaoVendaFutura,
    CompraProdutoNaoConfirmadaNoERP
  },
  data: () => ({
    focado: false,
    forcar_estoque_estetico: false,
    nao_validar_venda_futura: false,
    info_pedido_geral
  }),
  computed: {
    ...mapGetters({
      configuracoes: "configuracoes/carrinho",
      FILTROS_STORE: "CompraProdutosGerais/getFiltros",
    }),
    inputListeners() {
      return Object.assign({}, this.$listeners);
    },
    LOTE_MINIMO_VALIDO() {
      return verificarMultiploLoteMinimo(this.produto.sugestao, this.produto.lote_minimo);
    },
    ESTOQUE_ESTETICO_VALIDO() {
      const sugestao = Number(this.produto.sugestao).toFixed(4);
      const estoque_minimo = Number(this.produto.estoque_minimo).toFixed(4);
      const estoque = Number(this.produto.estoque).toFixed(4);
      const estoque_transito = Number(this.produto.estoque_transito).toFixed(4);
      return (Number(sugestao) + Number(estoque) + Number(estoque_transito)) >= Number(estoque_minimo)
    },
    QUANTIDADE_VENDA_FUTURA_VALIDA() {
      return validarVendaFutura({
        quantidade_compra: Number(this.produto.sugestao),
        quantidade_sugestao: Number(this.produto.sugestao_fixa),
        quantidade_venda_futura: Number(this.produto.estoque_pendente)
      });
    },
    COMPRA_MULTIFILIAL_ATIVADA() {
      return this.$store.getters['CompraDistribuidaPorFilial/get_distribuir_por_filial'];
    },
  },
  methods: {
    validarVendaFutura,
    formatarValor,
    adicionarNoCarrinhoComDaley(daley = 100) {
      setTimeout(this.adicionarNoCarrinho, daley);
    },
    adicionarNoCarrinho() {
      if (this.produto.produto_esta_combinado) {
        return;
      }

      if (this.produto.sugestao <= 0) {
        return;
      }

      if (!this.LOTE_MINIMO_VALIDO) {
        this.$refs.loteMinimoRef.ativador_menu = true;
        this.nao_validar_venda_futura = false;
        return;
      }

      if (!this.ESTOQUE_ESTETICO_VALIDO && !this.forcar_estoque_estetico) {
        this.$refs.alertaEstoqueEsteticoRef.ativador_menu = true;
        this.nao_validar_venda_futura = false;
        return;
      }

      if (!this.QUANTIDADE_VENDA_FUTURA_VALIDA && !this.nao_validar_venda_futura) {
        this.$refs.alertaVendaFuturaRef.menu_ativo = true;
        return;
      }

      this.$emit('add-produto-carrinho', this.produto);
    },
    focus() {
      if (!this.$refs.inputRef) return;
      this.$refs.inputRef.focus();
    }
  }
}
</script>

<style scoped>

</style>
